export const formatErrorMessage = error => {
  let data = error.response?.data

  if (error.request?.responseType === 'arraybuffer') {
    data = JSON.parse(new TextDecoder().decode(error.request.response))
  }

  if (data !== null || data !== undefined) {
    return data?.message || error.message
  }

  return ''
}

export const parseBlobErrorResponse = async (error) => {
  if (error.response?.data instanceof Blob) {
    const blob = error.response.data;
    const text = await blob.text();
    let errorMessage = '';

    try {
      const json = JSON.parse(text);
      errorMessage = json.message || 'Fisierul nu a fost gasit';
    } catch (e) {
      errorMessage = text;
    }

    return errorMessage;
  } else {
    return formatErrorMessage(error);
  }
};
